var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "transition-group",
        { attrs: { name: "list-complete", tag: "div" } },
        _vm._l(_vm.action_plan_origins, function(action_plan_origin, index) {
          return _c(
            "div",
            {
              key: `${action_plan_origin.datetime}-${index}`,
              staticClass: "list-complete-item"
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("v-autocomplete", {
                    staticClass: "px-2",
                    attrs: {
                      items: _vm.origins,
                      "item-text": "name",
                      "item-value": "id",
                      rules: [
                        v =>
                          !!v ||
                          _vm.generateMessage("actionplans.create.noorigin")
                      ],
                      label: _vm.generateMessage("actionplans.create.origin"),
                      required: "",
                      outlined: "",
                      dense: ""
                    },
                    model: {
                      value: action_plan_origin.origin_subtype_id,
                      callback: function($$v) {
                        _vm.$set(action_plan_origin, "origin_subtype_id", $$v)
                      },
                      expression: "action_plan_origin.origin_subtype_id"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    staticClass: "px-2",
                    attrs: {
                      label: "Date origine",
                      type: "datetime-local",
                      dense: "",
                      outlined: "",
                      min: "2010-06-07T00:00"
                    },
                    model: {
                      value: action_plan_origin.datetime,
                      callback: function($$v) {
                        _vm.$set(action_plan_origin, "datetime", $$v)
                      },
                      expression: "action_plan_origin.datetime"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function({ on }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.handleRemoveOrigin(index)
                                        }
                                      }
                                    },
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.generateMessage(
                                "actionplans.create.origins.remove"
                              )
                            ) +
                            "\n          "
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.handleAddOrigin.apply(null, arguments)
                          }
                        }
                      },
                      on
                    ),
                    [_c("v-icon", [_vm._v("add_box")])],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.generateMessage("actionplans.create.origins.add")) +
                "\n    "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }